export default "__VITE_ASSET__pmMVoOZ9__"